import { useMemo } from "react";
import { Paper } from "@mui/material";
import WGRTable from "./c8Table";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /* Shop Total */
  const totals = useMemo(() => {
    return rows.reduce((total, row) => {
      // Labour
      const totalLabour =
        Number(row["DIRECT LABOUR"] || 0) +
        Number(row["ON COST LABOUR"] || 0);

      // Store
      const totalStore =
        Number(row["ON COST STORE"] || 0) +
        Number(row["DIRECT STORE"] || 0);

      // Freight
      const freight =
        totalStore *
        (Number(row["StoreFreight"] || 0) / 100);

      // Proforma
      const proforma =
        totalLabour *
        (Number(row["proformaoncost"] || 0) / 100);

      // Row Grand Total
      const grandTotal =
        totalLabour +
        totalStore +
        freight +
        proforma;

      return {
        TotalLabour:
          total.TotalLabour + totalLabour,

        TotalStore:
          total.TotalStore + totalStore,

        Freight:
          total.Freight + freight,

        Proforma:
          total.Proforma + proforma,

        GrandTotal:
          total.GrandTotal + grandTotal,
      };
    }, {
      TotalLabour: 0,
      TotalStore: 0,
      Freight: 0,
      Proforma: 0,
      GrandTotal: 0,
    });
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      <WGRTable
        rows={rows}
        shop={shop}
        totals={totals}
        showTotal={true}
      />
    </Paper>
  );
}